import { Form, Formik } from 'formik';
import InputFormik from '../../Common/Formik/Input';
import { Link } from '@lana-ui/common';
import Label from '../../Common/Formik/Label';
import { Button } from '@lana-ui/login';
import ValidacionDomicilio from '../../../Validations/ValidacionDomicilios';
import useNormalizarDomicilio from '../../../Hooks/useNormalizarDomicilio';
import LoadingSpinner from '../../../Helpers/LoadingSpinner';
import '@styles/Features/formNormalizarDomicilio.scss';

const FormNormalizarDomicilio = ({ tipoPropiedadSelected, seleccionCountry, setErrorNormalizar, setIsLoadingNormalizar, setIsLastStep, setDomicilioElegido }) => {
    const [domicilio, errorNormalizar, isLoading, sendNormalizar] = useNormalizarDomicilio();

    const handleSubmit = (e) => {
        const domicilioANormalizar = { ...e, tipoPropiedadSelected };

        if (!seleccionCountry) {
            setIsLoadingNormalizar(true);
            sendNormalizar({
                calle: domicilioANormalizar.calle,
                altura: domicilioANormalizar.altura,
                cp: domicilioANormalizar.codigoPostal,
            }).then((resp) => {
                setIsLoadingNormalizar(false);
                if (resp.code !== '0000') {
                    setErrorNormalizar(resp.message);
                    const domicilioSend = {
                        calle: domicilioANormalizar.calle,
                        altura: domicilioANormalizar.altura,
                        codigoPostal: domicilioANormalizar.codigoPostal,
                    };
                    setDomicilioElegido(domicilioSend);
                    setIsLastStep(true);
                } else {
                    setErrorNormalizar(null);
                    setIsLastStep(true);
                    setDomicilioElegido(resp.response);
                }
            });
        } else {
            setIsLastStep(true);
            setDomicilioElegido(domicilioANormalizar);
        }
    };

    return (
        <>
            <LoadingSpinner isLoading={isLoading}>
                <Formik
                    initialValues={{
                        calle: tipoPropiedadSelected == 'country' && seleccionCountry ? seleccionCountry.Calle : '',
                        altura: tipoPropiedadSelected == 'country' && seleccionCountry ? seleccionCountry.Altura : '',
                        codigoPostal: tipoPropiedadSelected == 'country' && seleccionCountry ? seleccionCountry.CodigoPostal.replace(/\D/g, '') : '',
                    }}
                    enableReinitialize
                    validationSchema={ValidacionDomicilio}
                    onSubmit={handleSubmit}
                >
                    {() => (
                        <Form className="domicilios">
                            <div className="--mb-24">
                                <Label text={'Domicilio'} />
                                <InputFormik disabled={tipoPropiedadSelected === 'country'} id="calle" type="text" name="calle" placeholder="Ingresá la calle" />
                            </div>
                            <div className="inputs --mb-24">
                                <div>
                                    <Label text="Número" />
                                    <InputFormik disabled={tipoPropiedadSelected === 'country'} name="altura" type="text" />
                                </div>
                                <div className="--mt-24-mobile">
                                    <Label text="Código postal" />
                                    <InputFormik disabled={tipoPropiedadSelected === 'country'} name="codigoPostal" type="text" />
                                    <Link size="5xs" href="https://www.correoargentino.com.ar/formularios/cpa" target="_blank">
                                        No sé mi código postal
                                    </Link>
                                </div>
                            </div>

                            <Button type="submit" label={'VALIDAR DOMICILIO'} className="--not-disabled submit-button" />
                        </Form>
                    )}
                </Formik>
            </LoadingSpinner>
        </>
    );
};

export default FormNormalizarDomicilio;
